export type PredefinedBasket = {
  id: number;
  friendlyName: string;
  baseAssets: string; // array of numbers separated by ,
  balanceDistribution: string; // array of floats separated by ,
};

export const PredefinedBasketsSortingMap: Record<string, number> = {
  "Owner's Choice": 0,
  'Top 10 Coins': 1,
  'Magnificent 7': 2,
  'Crypto Equities': 3,
  'Top 20 Coins': 4,
  'Crypto Equities & Miners': 5,
  'Streaming & Media': 6,
  'Broad Market & Bonds': 7,
  'Top 50 Coins': 8,
  'TradFi Sampler': 9,
  'Layer 1 Coins': 10,
  'Layer 2 Coins': 11,
  'AI Megatrend': 12,
  'Ethereum Ecosystem Coins': 13,
  Semiconductors: 14,
  'Solana Ecosystem Coins': 15,
  'AI & Quantum': 16,
  'Binance Ecosystem Coins': 17,
  'Cybersecurity & Software': 18,
  'Cardano Ecosystem Coins': 19,
  'Banks & Payments': 20,
  'Decentralized Finance Coins': 21,
  'Global E-commerce': 22,
  'Artificial Intelligence Coins': 23,
  'Energy & Nuclear': 24,
  'Real-World Assets Coins': 25,
  'Precious Metals': 26,
  'Gaming Coins': 27,
  'Fintech & Web3': 28,
  'Meme Coins': 29,
  'Healthcare & Pharma': 30,
  'Exchange Coins': 31,
  'Consumer Brands': 32,
  'Centralized Exchange Coins': 33,
  'Space & Defense': 34,
  'Decentralized Exchange Coins': 35,
  'Digital Gold': 36,
  'Made in USA Coins': 37,
};
